import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {PagesComponent} from "./pages/pages.component";
import {PagesGuard} from "./shared/guard/pages.guard";
import {AuthorizeComponent} from "./theme/components/authorize/authorize.component";

const routes: Routes = [
  {
    path: '',
    component: PagesComponent,
    canActivate: [PagesGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule),
        pathMatch: 'full'
      },
      {
        path: 'notes',
        loadChildren: () => import('./pages/notes/notes.module').then(m => m.NotesModule),
      },
      {
        path: 'extracts',
        loadChildren: () => import('./pages/extracts/extracts.module').then(m => m.ExtractsModule),
      },
      {
        path: 'report',
        loadChildren: () => import('./pages/report/report.module').then(m => m.ReportModule),
      },
    ]
  },
  {
    path: 'authorize',
    component: AuthorizeComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
